enum MedicoSolicitanteEnum {
  Sim = 'Sim',
  Nao = 'Nao',
}

export default MedicoSolicitanteEnum
